// extracted by mini-css-extract-plugin
export var alertIcon = "_ng-0";